module.exports = __webpack_public_path__ + "5740c71adb324d36343978e6f29da75e.png";